import { DayOfWeek } from '@evidentid/dashboard-commons/components/DayOfWeekInput/types';
import { NotificationName, RpFulfillmentConfig, SchedulePatternType } from '@evidentid/gateway-api-client/src/models';
import {
    NotificationConfiguration,
    NotificationType,
} from '@evidentid/tprm-portal-lib/models/notification-configuration';
import { OperationStatus } from '@evidentid/vue-commons/store/OperationStatus';

export enum TimeUnit {
    hours = 'hours',
    days = 'days',
    weeks = 'weeks',
}

export interface TimePhrase {
    amount: number;
    unit: TimeUnit;
}

export interface SchedulePattern {
    weekNumber: number | null;
    day: number;
    hour: number;
    minute: number;
}

export interface BrandingConfiguration {
    displayName: string;
    wordmarkUrl: string;
    /** Hexadecimal format **/
    primaryColor: string;
    /** Hexadecimal format **/
    secondaryColor: string;
}

export interface EmailConfiguration {
    fromName: string;
    replyToName: string;
    replyToEmail: string;
    /** URL format **/
    coiRequirementsLink: string | null;
    /** HTML format **/
    certificateHolderAddress: string | null;
    legacyFulfillmentUrl: string | null;
    fulfillmentConfiguration: RpFulfillmentConfig;
}

export interface SupportContactConfiguration {
    supportEmail: string | null;
    supportPhone: string | null;
    supportUrl: string | null;
    supportUrlTitle: string | null;
    supportDaysOfWeek: DayOfWeek[] | null;
    supportStartTime: string | null;
    supportEndTime: string | null;
    supportTimezone: string | null;
}

export type ProfileConfiguration = BrandingConfiguration & SupportContactConfiguration;

export type NotificationsConfiguration = (
    BrandingConfiguration &
    EmailConfiguration &
    SupportContactConfiguration
    & { iconUri: string }
);

export interface NotificationCadence {
    recurrence: SchedulePatternType;
    limit: number;
    // Interval
    interval?: { amount: number, unit: TimeUnit };
    // Schedule / Pattern
    daysOfWeek?: number[];
    sendsAt?: number[];
    timezone?: string;
    // Sequence / Cadence
    daysBeforeCount?: number;
    daysBefore?: number[];
    daysAfter?: number[];
    initEnabled: boolean;
    remindersEnabled: boolean;
}

export interface NotificationsConfigurationState {
    settings: Record<string, NotificationsConfiguration>;
    loadSettingsStatus: Record<string, OperationStatus>;
    updateSettingsStatus: Record<string, OperationStatus>;
    emailTemplates: Record<string, Record<NotificationType, NotificationConfiguration>>;
    loadEmailTemplatesStatus: Record<string, OperationStatus>;
    updateEmailTemplates: Record<string, Record<NotificationType, OperationStatus>>;
    loadInsuredFields: Record<string, OperationStatus>;
    insuredFields: Record<string, string[]>;
    cadences: Record<string, Record<NotificationName, NotificationCadence>>;
    loadCadences: Record<string, Record<NotificationName, OperationStatus>>;
    updateCadences: Record<string, Record<NotificationName, OperationStatus>>;
    sendTestEmailStatus: Record<string, OperationStatus>;
}
